import { client as request } from "../../api/request";

export interface CsvDate {
  // id: any;
  chengeDate: string;
}

/**
 * 工事内容を取得する
 */
export async function getCsvDate() {
  const csvDate = await request.get("get_m_csv_date.php", {});
  return csvDate;
}

/**
 * 工事内容を保存する
 */
export async function saveCsvDate(d: FormData) {
  const res = await request.post("save_m_csv_date.php", d);
  return res;
}
